import mixpanel from "mixpanel-browser";

interface MixpanelConfig {
  prodHost: string;
  devToken: string;
  prodToken: string;
  debug?: boolean;
}

export const initMixpanel = (config: MixpanelConfig) => {
  const isProd = window.location.hostname === config.prodHost;
  const isLocalhost = window.location.hostname === "localhost";
  const api_host = isLocalhost ? undefined : `${window.location.origin}/mp`;
  mixpanel.init(isProd ? config.prodToken : config.devToken, {
    api_host,
    debug: !isProd && (config.debug ?? false),
    record_sessions_percent: isProd ? 100 : 0,
    record_mask_all_text: false,
    record_mask_all_inputs: false,
  });
};
